import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityRemoveAttribute } from '../../projectDetailsActivities.models';
import { RenderRelatedAnnotationsCount } from './RenderRelatedAnnotationsCount2';

export const RemoveAttributeActivity = ({ values }: IProjectActivity<IProjectActivityRemoveAttribute>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_RemoveAttribute')}
      <b>{values.attribute}</b>
      <RenderRelatedAnnotationsCount
        strategy={values.strategy}
        count={values.updatedAnnotationsCount}
      />
      .
    </span>
  );
};
